
import React, { useState, useEffect, useContext} from 'react'

import { Link, useNavigate, useLocation } from 'react-router-dom';
import { flightsData } from '../../../../data';

import { Container, Card, Button, Form , Col, Row, } from 'react-bootstrap';
import AppContext from '../../../../AppContext';
import air from '../../../../images/air.png'
import airplane from '../../../../images/airplane.png'
import share from '../../../../images/share.svg'
import wallet from '../../../../images/wallet.svg'
import liner from '../../../../images/liner.svg'

const AvailableFlight = () => {
  const { selectedDeparture, selectedArrival } = useContext(AppContext);
  const [flights, setFlights] = useState(flightsData);
  const [filteredFlights, setFilteredFlights] = useState(flightsData);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [amount, setAmount] = useState(50000);
  // const [selectedAmountRange, setSelectedAmountRange] = useState([50000, 500000]);
  const [minAmount, setMinAmount] = useState(50000);
  const [maxAmount, setMaxAmount] = useState(500000);
  const [selectedRefundOption, setSelectedRefundOption] = useState('');
  const [selectedAirlineOption, setSelectedAirlineOption] = useState('');
  const [selectedStopOption, setSelectedStopOption] = useState('all');
  const navigate = useNavigate()


  const filterFlightsByStops = (option) => {
    setSelectedStopOption(option);

    let filteredFlights = [];

    if (option === 'direct') {
      filteredFlights = flights.filter((flight) => flight.stop === 'Direct');
    } else if (option === '1stop') {
      filteredFlights = flights.filter((flight) => flight.stop === '1 stop');
    } else if (option === '2+stops') {
      filteredFlights = flights.filter((flight) => flight.stop === '2+ stops');
    } else {
      filteredFlights = flights;
    }

    setFilteredFlights(filteredFlights);
    setSelectedAirlineOption('')
    setSelectedRefundOption('')
  };


  

  const filterByRecommendation = () => {
    const recommendedFlights = flights.filter(
      (flight) => flight.recommendation !== ''
    );
    setFilteredFlights(recommendedFlights);
    setSelectedFilter('recommendation');
  };
  const filterByCheapest = () => {
    const sortedFlights = [...flights].sort((a, b) => a.amount - b.amount);
    setFilteredFlights(sortedFlights);
    setSelectedFilter('cheapest');
  };

  const filterByDuration = () => {
    const sortedFlights = [...flights].sort(
      (a, b) => a.duration- b.duration
    );
    setFilteredFlights(sortedFlights);
    setSelectedFilter('duration');
  };
  const filterByAll = () => {
    
    setFilteredFlights(flightsData);
    setSelectedFilter('all');
  };

  const filterRefund = (option) => {
    setSelectedRefundOption(option);
    let filteredFlights = [];

    if (option === 'refundable') {
      filteredFlights = flights.filter((flight) => flight.refundable === 'Refundable');
    } else if (option === 'nonRefundable') {
      filteredFlights = flights.filter((flight) => flight.refundable === 'Non-refundable');
    } else {
      filteredFlights = flights;
    }

    setFilteredFlights(filteredFlights);
    setSelectedAirlineOption('')
    setSelectedStopOption('')
  };

  const handleClear = () => {
    
    setFilteredFlights(flightsData);
    setSelectedAirlineOption('')
    setSelectedRefundOption('')
    setSelectedStopOption('')
    handleClearAmount()
  
  };

  const filterAirline = (option) => {
    setSelectedAirlineOption(option);
    let filteredFlights = [];

    if (option === 'all') {
      filteredFlights = flightsData;
    } else if (option === 'nigerianAirways') {
      filteredFlights = flights.filter((flight) => flight.airline === 'Nigerian Airways');
    } else if (option === 'ibomAir') {
      filteredFlights = flights.filter((flight) => flight.airline === 'Ibom Air');
    } else if (option === 'ethiopianAir') {
      filteredFlights = flights.filter((flight) => flight.airline === 'Ethiopian Air');
    } 

    setFilteredFlights(filteredFlights);
    setSelectedRefundOption('')
    setSelectedStopOption('')

  };
  useEffect(() => {
    const updatedFilterByAmount = flightsData.filter(
      (flight) => flight.amount >= minAmount && flight.amount <= maxAmount
    );
    setFilteredFlights(updatedFilterByAmount);
  }, [minAmount, maxAmount]);

  const handleMinAmountChange = (e) => {
    setMinAmount(parseInt(e.target.value));
  };

  const handleMaxAmountChange = (e) => {
    setMaxAmount(parseInt(e.target.value));
  };
  const handleClearAmount = () => {
    setMinAmount(50000);
    setMaxAmount(500000);
  };
  

  const handleSelectFlight = (flightId) => {
    // Navigate to the ItineraryPage with the selected flight ID
    navigate(`/flight-itinerary/${flightId}`);
  };

  return (
    <div  className='' >
      <Card className='border-0  available-container d-none d-md-block'>
          <Card.Img src={air} alt='air' style={{maxHeight:'500px'}} className=''/>
          
          
          <Card.ImgOverlay  className='p-3 p-xl-5 p-lg-2 p-md-5 mt-3 mt-md-5 mx-md-4 mx-2'>
              <div className=''>
                <div className='d-block d-md-none'>
                <div className=' text-center'>
                <Button onClick={handleClear} className=' text-white' style={{width:'200px', border: '2px solid #008080', background:'#008080'}}>Modify</Button>

                </div>
                </div>
                <div className='d-none d-md-block'>
                <div className=' text-center'>
                <Button onClick={handleClear} className=' active text-white' style={{width:'200px', border: '2px solid #008080', background:'none'}}>Modify</Button>

                </div>
                </div>
                
                <div className='mt-5'>
                  <Row className=''>
                    <Col xs={12} md={12} lg={4}>
                    <div className='' style={{background:'#fafafa'}}>
                      <div className='d-flex p-3 justify-content-between align-items-center'>
                          <h5>Filter</h5>
                          <p className='forgot-password' onClick={handleClear}>Clear</p>
                          
                      </div>
                      <div className='line' style={{width:'100%'}}></div>
                      <div className='p-3'>
                        <h5>No of stops</h5>
                        <div className='d-flex gap-3 mt-1'>
                          <button className={selectedStopOption === 'direct' ? 'active-stop' : 'stop'}
          onClick={() => filterFlightsByStops('direct')}>Direct</button>
                          <button className={selectedStopOption === '1stop' ? 'active-stop' : 'stop'}onClick={() => filterFlightsByStops('1stop')}>1 stop</button>
                          <button className={selectedStopOption === '2+stops' ? 'active-stop' : 'stop'}onClick={() => filterFlightsByStops('2+stops')}>2+ stops</button>
                        </div>
                      </div>
                      <div className='line' style={{width:'100%'}}></div>
                      <div className='p-3 '>
                      <div className='d-flex justify-content-between align-items-center'>
                          <h5>Price</h5>
                          <p className='forgot-password' onClick={handleClearAmount}>Clear</p>
                          
                      </div>
                      <Form className='d-flex' >
           
             <Form.Group>
          
          <Form.Range 
            min="50000"
            max="500000"
            step="10000"
            value={minAmount}
            onChange={handleMinAmountChange}
          /><Form.Label>{minAmount.toLocaleString()}</Form.Label>
        </Form.Group>
        <Form.Group>
          
          <Form.Range 
            min="50000"
            max="500000"
            step="10000"
            value={maxAmount}
            onChange={handleMaxAmountChange}
          />
          <div className='d-flex flex-row-reverse'><Form.Label > {maxAmount.toLocaleString()}</Form.Label></div>
        </Form.Group>
          </Form>
                      </div>
                      <div className='line' style={{width:'100%'}}></div>
                      <div className='p-3'>
                        <h5>Payment type</h5>
                        <div className='mt-4'>
                          <Form>
                          <Form.Group className="mb-2" controlId="formBasicCheckbox">
                          <Form.Check
        type="checkbox"
        id="refundableCheckbox"
        label="Refundable"
        checked={selectedRefundOption === 'refundable'}
        onChange={() => filterRefund('refundable')}
      />
      </Form.Group>
      <Form.Group className="" controlId="formBasicCheckbox">
      <Form.Check
        type="checkbox"
        id="nonRefundableCheckbox"
        label="Non-refundable"
        checked={selectedRefundOption === 'nonRefundable'}
        onChange={() => filterRefund('nonRefundable')}
      />
      </Form.Group>
                          </Form>
                        </div>
                      </div>
                      <div className='line' style={{width:'100%'}}></div>
                      <div className='p-3'>
                        <h5>Airline</h5>
                        <div className='mt-4'>
                          <Form>
                          <Form.Group className="mb-2" controlId="formBasicCheckbox">
        <Form.Check type="checkbox"
        id="allCheckbox"
        label="All"
        checked={selectedAirlineOption === 'all'}
        onChange={() => filterAirline('all')} />
      </Form.Group>
      <Form.Group className="mb-2" controlId="formBasicCheckbox">
        <Form.Check   type="checkbox"
        id="nigerianAirwaysCheckbox"
        label="Nigerian Airways"
        checked={selectedAirlineOption === 'nigerianAirways'}
        onChange={() => filterAirline('nigerianAirways')}/>
      </Form.Group>
      <Form.Group className="mb-2" controlId="formBasicCheckbox">
        <Form.Check   type="checkbox"
        id="ibomAirCheckbox"
        label="Ibom Air"
        checked={selectedAirlineOption === 'ibomAir'}
        onChange={() => filterAirline('ibomAir')} />
      </Form.Group>
      <Form.Group className="" controlId="formBasicCheckbox">
        <Form.Check   type="checkbox"
        id="ethiopianAirCheckbox"
        label="Ethiopian Airline"
        checked={selectedAirlineOption === 'ethiopianAir'}
        onChange={() => filterAirline('ethiopianAir')} />
      </Form.Group>
                          </Form>
                        </div>
                      </div>
                    </div>
                    </Col>
                    <Col>
                    <div className='mt-3 mt-lg-0'>
                      <div className='d-block d-sm-flex  p-3 gap-4 align-items-center mb-3'style={{background:'#fafafa'}}>
                        <h5 className=' mb-3 mb-sm-0'>Sort by</h5>
                        <div className='d-block d-sm-flex gap-2'>
                        <button  onClick={filterByAll}
          className={selectedFilter === 'all' ? 'active-filter' : 'filter-button'}> All</button>
                          <button  onClick={filterByCheapest}
          className={selectedFilter === 'cheapest' ? 'active-filter' : 'filter-button'}> Cheapest</button>
                          <button  onClick={filterByDuration}
          className={selectedFilter === 'duration' ? 'active-filter' : 'filter-button'}> Duration</button>
                          <button onClick={filterByRecommendation}
          className={selectedFilter === 'recommendation' ? 'active-filter' : 'filter-button'}> Recommendation</button>
                        </div>
                      </div>
                      <div className=''>
                          {
                            filteredFlights.map((flight) => {
                              const {id,
                                icon,
                                airline,
                                departureTime,
                                from,
                                to,
                                arrivalTime,
                                stop,
                                duration,
                                amount,
                            recommendation,
                            refundable} = flight;
                            return (
                              <Row key={id}className='gap-2 mb-4 mb-md-2'>
                                <Col className=' ' md={8} style={{background:'#fafafa'}} >
                                 <Row className='py-3 align-items-center' >
                                  <Col xs={12} xl={4} className='d-flex gap-1 mb-2 mb-sm-0' >
                                  <img src={icon} alt='icon' style={{height:'60px',width:'50px'}} />
                                  <p className='my-auto'>{airline}</p>
                                  </Col>
                                  <Col className=' mb-2 mb-sm-0'>
                                  <p><b>{departureTime}</b> &nbsp;{selectedDeparture}</p>                                
                                  </Col>
                                  <Col className='text-align-center justify-content-center align-items-center '>
                                  <p className='align-items-center p-0 m-0 mx-auto'><b>{duration} hours</b></p>
                                  <img src={liner} alt='liner' className='p-0 m-0 justify-content-center align-items-center text-center '/> 
                                  <p className='align-items-center mx-auto p-0 m-0'>{stop}</p>
                                  </Col>
                                  <Col className=''>
                                  <p><b>{arrivalTime}</b> {selectedArrival}</p>
                                  </Col>
                                 </Row>
                                 <div className='line' style={{width:'100%'}}>
                                 </div>
                                 <div className='d-flex  gap-3 p-3 align-items-center'>
                                  <div className='d-flex align-items-center gap-1'><img src={airplane} alt='airplane'/> <p className='my-auto'>Flight deals</p></div>
                                  <div className='d-flex gap-1'><img src={wallet}/> <p className='my-auto'>Baggage</p></div>
                                  <div className='d-flex'><img src={share} alt='share'/> <p className='my-auto'>Share</p></div>
                                 </div>
                                </Col>
                                <Col className='align-items-center justify-content-center text-center p-3 ' style={{background:'#fafafa'}}>
                                <div className='d-flex mb-2 justify-content-center'>
                                <p>NGN</p>
       &nbsp;                         <h4>{amount.toLocaleString()}</h4>
                                </div>
                                <div className='mb-2'>
                                <Button onClick={() => handleSelectFlight(flight.id)} style={{height: '48px',
width: '120px',

borderRadius: '8px',

backgroundColor: '#008080'}}>
        Select
        </Button>
                                </div>
                                <p className='refund'> {refundable}</p>
                                </Col>
                              </Row>
                            )
                            })
                          }
                      </div>
                    </div>
                    </Col>
                  </Row>
                </div>
              </div>
          </Card.ImgOverlay>
         
          </Card>
          <div  className='d-block d-md-none p-3 p-xl-5 p-lg-2 p-md-5 mt-3 mt-md-5 mx-md-4 mx-2 mb-5'>
              <div className=''>
                <div className='d-block d-md-none'>
                <div className=' text-center'>
                <Button onClick={handleClear} className=' text-white' style={{width:'200px', border: '2px solid #008080', background:'#008080'}}>Modify</Button>

                </div>
                </div>
                <div className='d-none d-md-block'>
                <div className=' text-center'>
                <Button onClick={handleClear} className=' active text-white' style={{width:'200px', border: '2px solid #008080', background:'none'}}>Modify</Button>

                </div>
                </div>
                
                <div className='mt-5'>
                  <Row className=''>
                    <Col xs={12} md={12} lg={4}>
                    <div className='' style={{background:'#fafafa'}}>
                      <div className='d-flex p-3 justify-content-between align-items-center'>
                          <h5>Filter</h5>
                          <p className='forgot-password' onClick={handleClear}>Clear</p>
                          
                      </div>
                      <div className='line' style={{width:'100%'}}></div>
                      <div className='p-3'>
                        <h5>No of stops</h5>
                        <div className='d-flex gap-3 mt-1'>
                          <button className={selectedStopOption === 'direct' ? 'active-stop' : 'stop'}
          onClick={() => filterFlightsByStops('direct')}>Direct</button>
                          <button className={selectedStopOption === '1stop' ? 'active-stop' : 'stop'}onClick={() => filterFlightsByStops('1stop')}>1 stop</button>
                          <button className={selectedStopOption === '2+stops' ? 'active-stop' : 'stop'}onClick={() => filterFlightsByStops('2+stops')}>2+ stops</button>
                        </div>
                      </div>
                      <div className='line' style={{width:'100%'}}></div>
                      <div className='p-3 '>
                      <div className='d-flex justify-content-between align-items-center'>
                          <h5>Price</h5>
                          <p className='forgot-password' onClick={handleClearAmount}>Clear</p>
                          
                      </div>
                      <Form className='d-flex' >
           
             <Form.Group>
          
          <Form.Range 
            min="50000"
            max="500000"
            step="10000"
            value={minAmount}
            onChange={handleMinAmountChange}
          /><Form.Label>{minAmount.toLocaleString()}</Form.Label>
        </Form.Group>
        <Form.Group>
          
          <Form.Range 
            min="50000"
            max="500000"
            step="10000"
            value={maxAmount}
            onChange={handleMaxAmountChange}
          />
          <div className='d-flex flex-row-reverse'><Form.Label > {maxAmount.toLocaleString()}</Form.Label></div>
        </Form.Group>
          </Form>
                      </div>
                      <div className='line' style={{width:'100%'}}></div>
                      <div className='p-3'>
                        <h5>Payment type</h5>
                        <div className='mt-4'>
                          <Form>
                          <Form.Group className="mb-2" controlId="formBasicCheckbox">
                          <Form.Check
        type="checkbox"
        id="refundableCheckbox"
        label="Refundable"
        checked={selectedRefundOption === 'refundable'}
        onChange={() => filterRefund('refundable')}
      />
      </Form.Group>
      <Form.Group className="" controlId="formBasicCheckbox">
      <Form.Check
        type="checkbox"
        id="nonRefundableCheckbox"
        label="Non-refundable"
        checked={selectedRefundOption === 'nonRefundable'}
        onChange={() => filterRefund('nonRefundable')}
      />
      </Form.Group>
                          </Form>
                        </div>
                      </div>
                      <div className='line' style={{width:'100%'}}></div>
                      <div className='p-3'>
                        <h5>Airline</h5>
                        <div className='mt-4'>
                          <Form>
                          <Form.Group className="mb-2" controlId="formBasicCheckbox">
        <Form.Check type="checkbox"
        id="allCheckbox"
        label="All"
        checked={selectedAirlineOption === 'all'}
        onChange={() => filterAirline('all')} />
      </Form.Group>
      <Form.Group className="mb-2" controlId="formBasicCheckbox">
        <Form.Check   type="checkbox"
        id="nigerianAirwaysCheckbox"
        label="Nigerian Airways"
        checked={selectedAirlineOption === 'nigerianAirways'}
        onChange={() => filterAirline('nigerianAirways')}/>
      </Form.Group>
      <Form.Group className="mb-2" controlId="formBasicCheckbox">
        <Form.Check   type="checkbox"
        id="ibomAirCheckbox"
        label="Ibom Air"
        checked={selectedAirlineOption === 'ibomAir'}
        onChange={() => filterAirline('ibomAir')} />
      </Form.Group>
      <Form.Group className="" controlId="formBasicCheckbox">
        <Form.Check   type="checkbox"
        id="ethiopianAirCheckbox"
        label="Ethiopian Airline"
        checked={selectedAirlineOption === 'ethiopianAir'}
        onChange={() => filterAirline('ethiopianAir')} />
      </Form.Group>
                          </Form>
                        </div>
                      </div>
                    </div>
                    </Col>
                    <Col>
                    <div className='mt-3 mt-lg-0'>
                      <div className='d-block d-sm-flex  p-3 gap-4 align-items-center mb-3'style={{background:'#fafafa'}}>
                        <h5 className=' mb-3 mb-sm-0'>Sort by</h5>
                        <div className='d-block d-sm-flex gap-2'>
                        <button  onClick={filterByAll}
          className={selectedFilter === 'all' ? 'active-filter' : 'filter-button'}> All</button>
                          <button  onClick={filterByCheapest}
          className={selectedFilter === 'cheapest' ? 'active-filter' : 'filter-button'}> Cheapest</button>
                          <button  onClick={filterByDuration}
          className={selectedFilter === 'duration' ? 'active-filter' : 'filter-button'}> Duration</button>
                          <button onClick={filterByRecommendation}
          className={selectedFilter === 'recommendation' ? 'active-filter' : 'filter-button'}> Recommendation</button>
                        </div>
                      </div>
                      <div className=''>
                          {
                            filteredFlights.map((flight) => {
                              const {id,
                                icon,
                                airline,
                                departureTime,
                                from,
                                to,
                                arrivalTime,
                                stop,
                                duration,
                                amount,
                            recommendation,
                            refundable} = flight;
                            return (
                              <Row key={id}className='gap-2 mb-4 mb-md-2'>
                                <Col className=' ' md={8} style={{background:'#fafafa'}} >
                                 <Row className='py-3 align-items-center' >
                                  <Col xs={12} xl={4} className='d-flex gap-1 mb-2 mb-sm-0' >
                                  <img src={icon} alt='icon' style={{height:'60px',width:'50px'}} />
                                  <p className='my-auto'>{airline}</p>
                                  </Col>
                                  <Col className=' mb-2 mb-sm-0'>
                                  <p><b>{departureTime}</b> &nbsp;{selectedDeparture}</p>                                
                                  </Col>
                                  <Col className='text-align-center justify-content-center align-items-center '>
                                  <p className='align-items-center p-0 m-0 mx-auto'><b>{duration} hours</b></p>
                                  <img src={liner} alt='liner' className='p-0 m-0 justify-content-center align-items-center text-center '/> 
                                  <p className='align-items-center mx-auto p-0 m-0'>{stop}</p>
                                  </Col>
                                  <Col className=''>
                                  <p><b>{arrivalTime}</b> {selectedArrival}</p>
                                  </Col>
                                 </Row>
                                 <div className='line' style={{width:'100%'}}>
                                 </div>
                                 <div className='d-flex  gap-3 p-3 align-items-center'>
                                  <div className='d-flex align-items-center gap-1'><img src={airplane} alt='airplane'/> <p className='my-auto'>Flight deals</p></div>
                                  <div className='d-flex gap-1'><img src={wallet} alt='wallet'/> <p className='my-auto'>Baggage</p></div>
                                  <div className='d-flex'><img src={share} alt='share'/> <p className='my-auto'>Share</p></div>
                                 </div>
                                </Col>
                                <Col className='align-items-center justify-content-center text-center p-3 ' style={{background:'#fafafa'}}>
                                <div className='d-flex mb-2 justify-content-center'>
                                <p>NGN</p>
       &nbsp;                         <h4>{amount.toLocaleString()}</h4>
                                </div>
                                <div className='mb-2'>
                                <Button onClick={() => handleSelectFlight(flight.id)} style={{height: '48px',
width: '120px',

borderRadius: '8px',

backgroundColor: '#008080'}}>
        Select
        </Button>
                                </div>
                                <p className='refund'> {refundable}</p>
                                </Col>
                              </Row>
                            )
                            })
                          }
                      </div>
                    </div>
                    </Col>
                  </Row>
                </div>
              </div>
          </div>
    </div>
  )
}

export default AvailableFlight
